<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    燕南站<br>
站点介绍<br>
燕南站位于深圳市福田区，车站沿振华路布置，位于振华路与燕南路交叉路口的西侧，自西向东与燕南路垂直相交。燕南站毗邻深圳最繁华的商业步行街华强北，北侧主要有中联电子大厦、金茂礼都、格林酒店、沃尔玛、深圳市实验小学、妇幼保健院等；南侧以住宅区为主：富怡雅居、玮鹏花园、雍怡阁等；西侧有兰海路、华发北路；东侧有燕南路、上步中路。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:06	23:46	2号线	2分35秒	5分45秒<br>
莲塘	06:15	23:54	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:10	23:45	2号线	4分钟	5分钟<br>
莲塘	06:15	23:54	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:10	00:35	2号线	4分钟	5分钟<br>
莲塘	06:15	00:54	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
燕南路、CICCI Mall购物中心<br><br>
B出入口:<br>
振华路南侧、市府二办、深圳市住房和建设局、市建设工程质检中心、深圳市第二人民医院中西医结合分院、深圳城市学院<br><br>
C出入口:<br>
兰光路、振华路<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 市总工会<br>
4、8、12、高峰专线29号、M132、202、N17、75、B622、M202、M584、357、M383A出入口<br><br>
B出入口:<br>
公交站名： 建艺大厦①<br>
80、M555、75、M389<br><br>
B出入口:<br>
公交站名： 建艺大厦②<br>
M383<br><br>
B出入口:<br>
公交站名： 深圳城市学院<br>
M555、M389、M202、80<br><br>
C出入口:<br>
公交站名： 华发大厦①<br>
M383、M122<br><br>
C出入口:<br>
公交站名： 华发大厦②<br>
M555、75、M389、80<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>